const data = [
  {
    id: 'item_01',
    title: 'HAUGA 하우가',
    img: 'img/prod01.avif',
    price: 378900,
    desc: '침실가구2종, 180x200 cm',
    origin: '중국(China)',
    designer: 'Lisa Hilland',
    texture: '라미네이트 무늬목',
    desc02: '쿠션형 침대프레임 <br/> 아래에 수납함이 있어서 부드러운 침대와 넉넉한 수납공간을 동시에 활용할 수 있어요. 그레이 투톤 패브릭, 둥근 침대헤드와 파이핑으로 클래식한 스타일을 표현했으며 오랫동안 사용할 수 있습니다.',
  },
  {
    id: 'item_02',
    title: 'MALM 말름',
    img: 'img/prod02.avif',
    price: 228900,
    desc: '침실가구2종, 화이트',
    origin: '중국(China)',
    designer: 'Lisa Hilland',
    texture: '라미네이트 무늬목',
    desc02: '원목 무늬목으로 깔끔한 디자인이 돋보입니다. 독립형으로 또는 침대헤드와 함께 사용할 수 있습니다. 바퀴가 있어 쉽게 넣고 뺄 수 있는 넉넉한 수납공간도 있어 더욱 편리합니다.'
  },
  {
    id: 'item_03',
    title: 'HEMNES 헴네스',
    img: 'img/prod03.avif',
    price: 877900,
    desc: '침실가구, 3종, 화이트 스테인, 80x200 cm',
    origin: '폴란드(Poland)',
    designer: 'Carina Bengs',
    texture: '소나무 원목',
    desc02: '지속가능한 방법으로 생산된 원목으로, 튼튼하고 재활용이 가능합니다. 시간이 지나도 원목 특유의 느낌이 잘 살아있죠. 다른 HEMNES/헴네스 시리즈 가구들과 함께 사용할 수 있습니다.'
  },
  {
    id: 'item_04',
    title: 'HAUGA 하우가',
    img: 'img/prod04.avif',
    price: 856800,
    desc: '침실가구, 5종, 로팔레트 베이지/화이트, 150x200 cm',
    origin: '중국(China)',
    designer: 'Lisa Hilland',
    texture: '라미네이트 무늬목',
    desc02: '쿠션형 침대프레임 아래에 수납함이 있어서 부드러운 침대와 넉넉한 수납공간을 동시에 활용할 수 있어요. 그레이 투톤 패브릭, 둥근 침대헤드와 파이핑으로 클래식한 스타일을 표현했으며 오랫동안 사용할 수 있습니다.'
  },
  {
    id: 'item_05',
    title: 'HAUGA 하우가',
    img: 'img/prod05.avif',
    price: 378800,
    desc: '침실가구, 3종',
    origin: '중국(China)',
    designer: 'Lisa Hilland',
    texture: '라미네이트 무늬목',
    desc02: '쿠션형 침대프레임 아래에 수납함이 있어서 부드러운 침대와 넉넉한 수납공간을 동시에 활용할 수 있어요. 그레이 투톤 패브릭, 둥근 침대헤드와 파이핑으로 클래식한 스타일을 표현했으며 오랫동안 사용할 수 있습니다.'
  },
  {
    id: 'item_06',
    title: 'HEMNES 헴네스',
    img: 'img/prod06.avif',
    price: 872800,
    desc: '침실가구, 4종, 블랙브라운, 150x200 cm',
    origin: '폴란드(Poland)',
    designer: 'Carina Bengs',
    texture: '소나무 원목',
    desc02: '지속가능한 방법으로 생산된 원목으로, 튼튼하고 재활용이 가능합니다. 시간이 지나도 원목 특유의 느낌이 잘 살아있죠. 다른 HEMNES/헴네스 시리즈 가구들과 함께 사용할 수 있습니다.'
  },
  {
    id: 'item_07',
    title: 'SONGESAND 송에산드',
    img: 'img/prod07.avif',
    price: 732800,
    desc: '침실가구, 4종, 화이트, 150x200 cm',
    origin: '이탈리아 (Italy)',
    designer: 'IKEA of Sweden',
    texture: '적층 무늬목',
    desc02: '단단하고 높은 침대프레임입니다. 모서리 옆선이 부드럽죠. 유행을 타지 않는 클래식한 디자인입니다. 침대 밑에 여분의 침구나 옷을 보관할 수 있는 넉넉한 수납상자가 있습니다.'
  },
  {
    id: 'item_08',
    title: 'BRIMNES 브림네스',
    img: 'img/prod08.avif',
    price: 952000,
    desc: '침실가구, 3종, 화이트, 150x200 cm',
    origin: '이탈리아 (Italy)',
    designer: 'IKEA of Sweden/K Hagberg/M Hagberg',
    texture: '적층 무늬목',
    desc02: '여러 곳에 수납공간이 숨겨져 있는 침대프레임으로, 좁은 공간에서 사용하면 좋습니다. BRIMNES/브림네스 시리즈에는 공간 절약에 도움을 주는 여러 스마트 솔루션이 포함되어 있습니다.'
  },
  {
    id: 'item_09',
    title: 'MALM 말름',
    img: 'img/prod09.avif',
    price: 822800,
    desc: '침실가구, 4종, 화이트, 180x200 cm',
    origin: '중국(China)',
    designer: 'Lisa Hilland',
    texture: '라미네이트 무늬목',
    desc02: '원목 무늬목으로 깔끔한 디자인이 돋보입니다. 독립형으로 또는 침대헤드와 함께 사용할 수 있습니다. 바퀴가 있어 쉽게 넣고 뺄 수 있는 넉넉한 수납공간도 있어 더욱 편리합니다.'
  },
  {
    id: 'item_10',
    title: 'SONGESAND 송에산드',
    img: 'img/prod10.avif',
    price: 931800,
    desc: '침실가구, 5종, 화이트, 150x200 cm',
    origin: '이탈리아 (Italy)',
    designer: 'IKEA of Sweden',
    texture: '적층 무늬목',
    desc02: '단단하고 높은 침대프레임입니다. 모서리 옆선이 부드럽죠. 유행을 타지 않는 클래식한 디자인입니다. 침대 밑에 여분의 침구나 옷을 보관할 수 있는 넉넉한 수납상자가 있습니다.'
  },
  {
    id: 'item_11',
    title: 'MALM 말름',
    img: 'img/prod11.avif',
    price: 433900,
    desc: '침실가구 2종, 화이트, 150x200 cm',
    origin: '중국(China)',
    designer: 'Lisa Hilland',
    texture: '라미네이트 무늬목',
    desc02: '원목 무늬목으로 깔끔한 디자인이 돋보입니다. 독립형으로 또는 침대헤드와 함께 사용할 수 있습니다. 바퀴가 있어 쉽게 넣고 뺄 수 있는 넉넉한 수납공간도 있어 더욱 편리합니다.'
  },
  {
    id: 'item_12',
    title: 'MALM 말름',
    img: 'img/prod12.avif',
    price: 513800,
    desc: '침실가구, 3종, 화이트, 150x200 cm',
    origin: '중국(China)',
    designer: 'Lisa Hilland',
    texture: '라미네이트 무늬목',
    desc02: '원목 무늬목으로 깔끔한 디자인이 돋보입니다. 독립형으로 또는 침대헤드와 함께 사용할 수 있습니다. 바퀴가 있어 쉽게 넣고 뺄 수 있는 넉넉한 수납공간도 있어 더욱 편리합니다.'
  },
  {
    id: 'item_13',
    title: 'BRIMNES 브림네스',
    img: 'img/prod13.avif',
    price: 793000,
    desc: '침실가구2종, 화이트, 180x200 cm',
    origin: '이탈리아 (Italy)',
    designer: 'IKEA of Sweden/K Hagberg/M Hagberg',
    texture: '적층 무늬목',
    desc02: '여러 곳에 수납공간이 숨겨져 있는 침대프레임으로, 좁은 공간에서 사용하면 좋습니다. BRIMNES/브림네스 시리즈에는 공간 절약에 도움을 주는 여러 스마트 솔루션이 포함되어 있습니다.'
  },
  {
    id: 'item_14',
    title: 'GURSKEN 구르스켄',
    img: 'img/prod14.avif',
    price: 233800,
    desc: '침실가구, 3종, 라이트베이지, 150x200 cm',
    origin: '중국 (China)',
    designer: 'IKEA of Sweden',
    texture: '적층 무늬목, 자작나무 무늬목',
    desc02: '간결하고 깔끔한 디자인이 멋스러운 GURSKEN 구르스켄 침대는 아파트나 게스트룸을 빠르고 쉽게 꾸미기 좋은 가구입니다. 같은 시리즈의 침대협탁, 서랍장, 옷장과 아주 잘 어울려요!'
  },
  {
    id: 'item_15',
    title: 'GURSKEN 구르스켄',
    img: 'img/prod15.avif',
    price: 263800,
    desc: '침실가구, 3종, 라이트베이지, 150x200 cm',
    origin: '중국 (China)',
    designer: 'IKEA of Sweden',
    texture: '적층 무늬목, 자작나무 무늬목',
    desc02: '간결하고 깔끔한 디자인이 멋스러운 GURSKEN 구르스켄 침대는 아파트나 게스트룸을 빠르고 쉽게 꾸미기 좋은 가구입니다. 같은 시리즈의 침대협탁, 서랍장, 옷장과 아주 잘 어울려요!'
  },
  {
    id: 'item_16',
    title: 'GURSKEN 구르스켄',
    img: 'img/prod16.avif',
    price: 323700,
    desc: '침실가구, 4종, 라이트베이지, 150x200 cm',
    origin: '중국 (China)',
    designer: 'IKEA of Sweden',
    texture: '적층 무늬목, 자작나무 무늬목',
    desc02: '간결하고 깔끔한 디자인이 멋스러운 GURSKEN 구르스켄 침대는 아파트나 게스트룸을 빠르고 쉽게 꾸미기 좋은 가구입니다. 같은 시리즈의 침대협탁, 서랍장, 옷장과 아주 잘 어울려요!'
  },
  {
    id: 'display_01',
    title: 'VÅRELD 보렐드',
    img: 'img/item01.avif',
    price: 9900,
    desc: '쿠션커버',
    origin: '인도 (India)',
    designer: 'IKEA of Sweden',
    texture: '면 100%',
    desc02: '지퍼 방식으로 쉽게 커버를 벗길 수 있습니다.'
  },
  {
    id: 'display_02',
    title: 'VITTSJÖ 빗셰',
    img: 'img/item02.avif',
    price: 59900,
    desc: '네스팅테이블 2종',
    origin: '중국 (China)',
    designer: 'IKEA of Sweden',
    texture: '강화유리, 스틸',
    desc02: '강화유리 상판은 얼룩이 잘 생기지 않고 청소도 편합니다.'
  },
  {
    id: 'display_03',
    title: 'MÖRBYLÅNGA 뫼르뷜롱아',
    img: 'img/item03.avif',
    price: 699000,
    desc: '테이블',
    origin: '루마니아 (Romania)',
    designer: 'S Lanneskog/J Marnell',
    texture: '두꺼운 오크무늬목, 참나무 원목',
    desc02: '오크 상단은 널빤지 느낌을 강조하여 표현되어 있고 플로팅 테이블 상판 및 더브테일 맞물림 디테일이 테이블에 공예품의 외관을 선사합니다. 개성이 가득하고 가족 및 친구들을 위한 공간이 충분한 테이블입니다.'
  },
  {
    id: 'display_04',
    title: 'UPPVIND 우프빈드',
    img: 'img/item04.avif',
    price: 99900,
    desc: '플로어스탠드',
    origin: '중국 (China)',
    designer: 'IKEA of Sweden',
    texture: '알루미늄, 폴리에스테르 ',
    desc02: '부드러운 느낌의 불빛이 따뜻하고 포근한 분위기를 연출합니다.'
  },
  {
    id: 'display_05',
    title: 'NÄVLINGE 네블링에',
    img: 'img/item05.avif',
    price: 39900,
    desc: 'LED플로어스탠드',
    origin: '중국 (China)',
    designer: 'IKEA of Sweden',
    texture: 'PC 플라스틱',
    desc02: 'NÄVLINGE/네블링에 시리즈에는 대부분의 용도에 적합한 등이 포함되어 있습니다. 실내에 편안하게 녹아드는 디자인의 깔끔한 등으로, 가정 내 어느 곳에서든 간편하게 사용하여 눈부심 없는 조명 효과를 얻을 수 있습니다.'
  },
  {
    id: 'display_06',
    title: 'LANDSKRONA 란스크로나',
    img: 'img/item06.avif',
    price: 379900,
    desc: '암체어',
    origin: '중국 (China)',
    designer: 'IKEA of Sweden',
    texture: '스틸, 크롬도금, 폴리우레탄, 폴리에스테르',
    desc02: '고탄성 폼 충전재를 넣어 보다 편안하고, 피부에 닿는 부분을 두꺼운 그레인 가죽으로 마감해 고급스러운 분위기를 자아냅니다. 그 외의 부분은 튼튼한 코팅 패브릭으로 제작하여 매력적인 디자인은 물론 합리적인 가격이라는 두 마리 토끼를 잡은 제품입니다.'
  },
]

export default data